import { useCallback } from 'react';

import { DEFAULT_API_PAGE_SIZE } from '~constants/consts';
import useRutter from '~hooks/useRutter/useRutter';
import { Pagination } from '~services/pagination';
import { useStores } from '~store';

export const RUTTER_CONNECTIONS_FIRST_PAGE = { limit: DEFAULT_API_PAGE_SIZE, page: 1 };

export default function useRutterConnections() {
  const { rutterIntegrationStore } = useStores();
  const { getConnections } = useRutter();

  const fetchConnections = useCallback(
    async (pagination: Pagination = RUTTER_CONNECTIONS_FIRST_PAGE) => {
      rutterIntegrationStore.fetchConnectionsStart();
      const response = await getConnections(pagination);
      rutterIntegrationStore.fetchConnectionsEnd(response?.data);

      return response;
    },
    [getConnections, rutterIntegrationStore],
  );

  return { fetchConnections };
}
